import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withApollo } from "react-apollo";
import { push } from 'connected-react-router';
import { Breadcrumb } from 'antd';
import { Link } from 'react-router-dom';

import ArticleForm from './components/ArticleForm';

import withGraphqlData from '../shared/components/withGraphqlData';
import { parseFormErrors } from '../shared/utils/form_errors';
import { CreateArticleFormOptionsQuery, CreateArticleMutation } from './queries';
import { prepareCreateArticleRecord } from './articleRecord';

class NewArticle extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(data) {
    const { client, push } = this.props;
    const record = prepareCreateArticleRecord(data);
    return client.mutate({ mutation: CreateArticleMutation, variables: { record } })
      .then(() => push('/news'))
      .catch(parseFormErrors);
  }

  render() {
    const { ModelTags, SneakerModels } = this.props.data;

    return (
      <div id="new-article">
        <Breadcrumb>
          <Breadcrumb.Item><Link to="/news">News</Link></Breadcrumb.Item>
          <Breadcrumb.Item>New Article</Breadcrumb.Item>
        </Breadcrumb>

        <div className="container">
          <ArticleForm
            onSubmit={this.handleSubmit}
            tags={ModelTags}
            sneakerModels={SneakerModels}
          />
        </div>
      </div>
    );
  }
}

export default compose(
  withGraphqlData(CreateArticleFormOptionsQuery),
  connect(null, { push }),
  withApollo,
)(NewArticle);
